<template>
  <div>
    <customModal
      v-if="modalData"
      v-show="modalData"
      :onModalClose="onModalClose"
      :onModalAccept="updateNoAnswerCalls"
      :modalData="modalData"
    ></customModal>

    <div
      v-if="hasFreeOrders && tableType == 'freeOrders'"
      class="sticky-top div_sticky_btn"
    >
      <button
        @click="sendFreeOrders"
        class="btn btn-success assignButton"
        ref="assignButton"
      >
        Назначить заявки ({{ getRunnerName() }})
      </button>
    </div>

    <form ref="form" action="">
      <table class="table table-bordered table-hover table-sm">
        <thead>
        <tr>
          <th v-if="tableType != 'freeOrders'">
            <input
              @change="toggleAllCheckboxes()"
              class="main_checkbox"
              type="checkbox"
            />
          </th>
          <th
            v-if="tableType != 'freeOrders' && tableType != 'subOrders'"
            width="100"
          ></th>
          <th>
            Номер
            <template
              v-if="tableType == 'freeOrders' || tableType == 'subOrders'"
            >
              <p class="column_legend">
                  <span
                    style="background:#FCC4C4;width:10px;height:10px;border:1px solid;display:inline-block;"
                  ></span>
                не хватает
              </p>
              <p class="column_legend">
                  <span
                    style="background:#BCE2F4;width:10px;height:10px;border:1px solid;display:inline-block;"
                  ></span>
                в дороге
              </p>
              <p class="column_legend">
                  <span
                    style="background:#F9E5AE;width:10px;height:10px;border:1px solid;display:inline-block;"
                  ></span>
                не хв на все
              </p>
            </template>
          </th>
          <th>План</th>
          <th>ФИО</th>
          <th>Адрес</th>
          <!-- <th class="mw-180">Метро</th> -->
          <th>Комментарий</th>
          <th>
            Телефон
            <p class="column_legend">
                <span
                  style="background:#BCE2F4;width:20px;height:10px;border:1px solid;display:inline-block;"
                ></span>
              по возможности позвонить за день до доставки
            </p>
          </th>
          <th>
            Препарат
          </th>
          <th>Сумма заявки</th>
          <th
            v-if="tableType == 'freeOrders' || tableType == 'subOrders'"
          ></th>
        </tr>
        </thead>
        <tbody>
        <template v-if="tableType == 'freeOrders'">
          <tr
            v-if="order.visible"
            v-bind:class="{ selected: selectedFreeOrders[order.id] }"
            @click="selectFreeOrder(order.id)"
            v-for="(order, index2) in sortByField(orders, 'timestamp')"
            :key="order.id"
            :ref="`tr_${order.id}`"
          >
            <td :class="colors_num[order.id]">
              <p v-html="printOrderId(order.id)"/>
              <p>
                <strong>{{ order.project }}</strong>
              </p>
              <p v-html="printnoAnswerCalls(order.num_nedozvonov)"></p>
            </td>
            <td>
              {{ order.date }}
              <button
                v-if="!order.showRebook"
                type="button"
                @click="showRebookOptions(order.id)"
                class="btn btn-warning btn-xs"
              >
                Перенос
              </button>
              <div v-if="order.showRebook">
                <select class="form-control" v-model="order.rebookDate">
                  <option
                    v-for="(date, index) in order.rebookDates"
                    :value="date.days"
                  >{{ date.date }}
                  </option
                  >
                </select>
                <button
                  type="button"
                  @click="updateOrder($event, order.id, 'rebookOrder')"
                  class="btn btn-success btn-xs w-100"
                >
                  перенести
                </button>
              </div>
            </td>
            <td
              v-html="
                  searchValueForReplace
                    ? `${order.client.name}`.replace(
                        searchValueForReplace,
                        `<span class='search_selected'>${searchValueForReplace}</span>`
                      )
                    : order.client.name
                "
            ></td>
            <td
              v-html="
                  searchValueForReplace
                    ? `${order.address}`.replace(
                        searchValueForReplace,
                        `<span class='search_selected'>${searchValueForReplace}</span>`
                      )
                    : order.address
                "
            >
              <!-- <div v-if="!order.showMetroMenu">
                <div v-html="printMetro(order)"></div>
                <div class="form-group text-center">
                  <button
                    @click="order.showMetroMenu = true"
                    class="btn btn-xs btn-info"
                    type="button"
                  >
                    Выбрать метро
                  </button>
                  <!--                                    <button @click="getMetroByApi($event, order)" class="btn btn-xs btn-success" type="button">Автоматически</button>-->
              <!-- </div>
            </div>
            <div v-if="order.showMetroMenu">
              <v-select
                v-model="order.metro"
                @keypress.enter.native.prevent=""
                label="title"
                placeholder="Метро"
                :filterable="false"
                :options="metroList"
                @search="onSearchMetro"
              >
                <template slot="no-options">
                  введите название станции..
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.title }}<br />{{ option.line.title }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.title }}
                  </div>
                </template>
              </v-select>

              <div class="form-group text-center p-t-5">
                <button
                  type="button"
                  @click="saveMetro($event, order)"
                  class="btn btn-xs btn-success"
                >
                  Ок
                </button>
                <button
                  type="button"
                  @click="order.showMetroMenu = false"
                  class="btn btn-xs btn-warning"
                >
                  Отмена
                </button>
              </div>
            </div> -->
            </td>
            <!-- <td class='metro_td'></td> -->
            <td>
              <form @submit="saveComment">
                <p v-if="order.possible_early">раньше при наличии</p>
                <input type="hidden" name="order_id" :value="order.id"/>
                <textarea
                  @change="showCommentButton(order.id)"
                  class="form-control"
                  name="comment"
                  rows="3"
                >{{ order.comment }}</textarea
                >
                <button
                  v-if="order.comment_btn"
                  class="btn btn-info btn-sm"
                  type="submit"
                >
                  Сохранить
                </button>
              </form>
            </td>
            <td :class="{ call_before: order.call_yestoday }">
              <div class="phone_td">
                <p v-for="phone in order.phones">
                  {{ printPhone(phone) }}
                  <span
                    @click="noAnsverPhoneCall(order.id, printPhone(phone))"
                  ><i class="icon-fa icon-fa-phone"></i
                  ></span>
                </p>
                <p class="bold_info" v-if="order.call_yestoday">
                  Позвонить за день
                </p>
              </div>
            </td>
            <td :class="colors[order.id]">
              <div v-for="(p, index3) in order.preps" :key="index3">
                <p>{{ p.drug.prep }} ({{ p.prep }}) - {{ p.num }}шт</p>
                <div class="flex">
                  <template v-if="p.drug.commentsbypak">
                    <div>
                      <i
                        v-tooltip="{
                            content: p.drug.commentsbypak,
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            offset: 20,
                            delay: {
                              show: 500,
                              hide: 300
                            }
                          }"
                        class="icon-fa icon-fa-info-circle"
                      ></i>
                    </div>
                  </template>
                  <template v-if="p.drug.computation_comment">
                    <i
                      v-tooltip="{
                          content: p.drug.computation_comment,
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 20,
                          delay: {
                            show: 500,
                            hide: 300
                          }
                        }"
                      class="icon-fa icon-fa-home"
                    ></i>
                  </template>
                  <div>
                    <i
                      v-tooltip="{
                          content: printFigures(p),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 20,
                          delay: {
                            show: 500,
                            hide: 300
                          }
                        }"
                      class="icon-fa icon-fa-exchange"
                    ></i>
                  </div>
                </div>
              </div>
            </td>
            <td>
              {{ printSumm(order) }}
            </td>
            <td>
              <button
                v-if="!order.showRejectMenu"
                type="button"
                @click="showRejectMenu(order.id)"
                class="btn btn-danger btn-xs"
              >
                Отказ
              </button>
              <div v-if="order.showRejectMenu">
                  <textarea
                    v-model="order.prichina_otkaza"
                    class="form-control"
                    placeholder="Причина отказа"
                    rows="3"
                  ></textarea>
                <button
                  type="button"
                  @click="updateOrder($event, order.id, 'rejectOrder')"
                  class="btn btn-danger btn-xs w-100"
                >
                  Отказ
                </button>
              </div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr
            :class="{ back_green: order.zp > 0 }"
            v-for="(order, index2) in sortByField(orders, 'ord')"
            :key="order.id"
          >
            <td>
              <input
                class="select_checkbox"
                type="checkbox"
                :name="`selected[${order.id}]`"
              />
            </td>
            <td v-if="tableType != 'freeOrders' && tableType != 'subOrders'">
              <input
                type="number"
                :name="`orderLine[${order.id}]`"
                :value="order.ord"
                vv-model="order.ord"
                class="form-control"
              />
            </td>

            <td :class="colors_num[order.id]">
              <p v-html="printOrderId(order.id)"/>
              <p>
                <strong>{{ order.project }}</strong>
              </p>
              <p v-html="printnoAnswerCalls(order.num_nedozvonov)"></p>
            </td>

            <td>
              {{ order.date }}
              <template v-if="tableType == 'subOrders'">
                <button
                  v-if="!order.showRebook"
                  type="button"
                  @click="showRebookOptions(order.id)"
                  class="btn btn-warning btn-xs"
                >
                  Перенос
                </button>
                <div v-if="order.showRebook">
                  <select class="form-control" v-model="order.rebookDate">
                    <option
                      v-for="(date, index) in order.rebookDates"
                      :value="date.days"
                    >{{ date.date }}
                    </option
                    >
                  </select>
                  <button
                    type="button"
                    @click="updateOrder($event, order.id, 'rebookOrder')"
                    class="btn btn-success btn-xs w-100"
                  >
                    перенести
                  </button>
                </div>
              </template>
            </td>
            <td
              v-html="
                  searchValueForReplace
                    ? `${order.client.name}`.replace(
                        searchValueForReplace,
                        `<span class='search_selected'>${searchValueForReplace}</span>`
                      )
                    : order.client.name
                "
            ></td>
            <td
              v-html="
                  searchValueForReplace
                    ? `${order.address}`.replace(
                        searchValueForReplace,
                        `<span class='search_selected'>${searchValueForReplace}</span>`
                      )
                    : order.address
                "
            ></td>
            <!-- <td class="metro_td">
              <div v-if="!order.showMetroMenu">
                <div v-html="printMetro(order)"></div>
                <div class="form-group text-center">
                  <button
                    @click="order.showMetroMenu = true"
                    class="btn btn-xs btn-info"
                    type="button"
                  >
                    Выбрать метро
                  </button>
                </div>
              </div>
              <div v-if="order.showMetroMenu">
                <v-select
                  v-model="order.metro"
                  @keypress.enter.native.prevent=""
                  label="title"
                  placeholder="Метро"
                  :filterable="false"
                  :options="metroList"
                  @search="onSearchMetro"
                >
                  <template slot="no-options">
                    введите название станции..
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.title }}<br />{{ option.line.title }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.title }}
                    </div>
                  </template>
                </v-select>

                <div class="form-group text-center p-t-5">
                  <button
                    type="button"
                    @click="saveMetro($event, order)"
                    class="btn btn-xs btn-success"
                  >
                    Ок
                  </button>
                  <button
                    type="button"
                    @click="order.showMetroMenu = false"
                    class="btn btn-xs btn-warning"
                  >
                    Отмена
                  </button>
                </div>
              </div>
            </td> -->
            <td>
              <form @submit="saveComment">
                <p v-if="order.possible_early">раньше при наличии</p>
                <input type="hidden" name="order_id" :value="order.id"/>
                <textarea
                  @change="showCommentButton(order.id)"
                  class="form-control"
                  name="comment"
                  rows="3"
                >{{ order.comment }}</textarea
                >
                <button
                  v-if="order.comment_btn"
                  class="btn btn-info btn-sm"
                  type="submit"
                >
                  Сохранить
                </button>
              </form>
            </td>
            <td :class="{ call_before: order.call_yestoday }">
              <div class="phone_td">
                <p v-for="phone in order.phones">
                  {{ printPhone(phone) }}
                  <span
                    @click="noAnsverPhoneCall(order.id, printPhone(phone))"
                  ><i class="icon-fa icon-fa-phone"></i
                  ></span>
                </p>
                <p class="bold_info" v-if="order.call_yestoday">
                  Позвонить за день
                </p>
              </div>
            </td>
            <td :class="colors[order.id]">
              <div v-for="(p, index3) in order.preps" :key="index3">
                <p>{{ p.drug.prep }} ({{ p.prep }}) - {{ p.num }}шт</p>
                <div class="flex">
                  <template v-if="p.drug.commentsbypak">
                    <div>
                      <i
                        v-tooltip="{
                            content: p.drug.commentsbypak,
                            placement: 'bottom-center',
                            classes: ['info'],
                            targetClasses: ['it-has-a-tooltip'],
                            offset: 20,
                            delay: {
                              show: 500,
                              hide: 300
                            }
                          }"
                        class="icon-fa icon-fa-info-circle"
                      ></i>
                    </div>
                  </template>
                  <template v-if="p.drug.computation_comment">
                    <i
                      v-tooltip="{
                          content: p.drug.computation_comment,
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 20,
                          delay: {
                            show: 500,
                            hide: 300
                          }
                        }"
                      class="icon-fa icon-fa-home"
                    ></i>
                  </template>
                  <div>
                    <i
                      v-tooltip="{
                          content: printFigures(p),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          offset: 20,
                          delay: {
                            show: 500,
                            hide: 300
                          }
                        }"
                      class="icon-fa icon-fa-exchange"
                    ></i>
                  </div>
                </div>
              </div>
            </td>
            <td>
              {{ printSumm(order) }}
            </td>
            <td v-if="tableType == 'subOrders'">
              <button
                v-if="!order.showRejectMenu"
                type="button"
                @click="showRejectMenu(order.id)"
                class="btn btn-danger btn-xs"
              >
                Отказ
              </button>
              <div v-if="order.showRejectMenu">
                  <textarea
                    v-model="order.prichina_otkaza"
                    class="form-control"
                    placeholder="Причина отказа"
                    rows="3"
                  ></textarea>
                <button
                  type="button"
                  @click="updateOrder($event, order.id, 'rejectOrder')"
                  class="btn btn-danger btn-xs w-100"
                >
                  Отказ
                </button>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
      <div v-if="tableType != 'freeOrders'" class="flex flex-padding-10">
        <template
          v-if="tableType == 'subOrders' || tableType == 'assignedOrders'"
        >
          <div>
            <button
              @click="updateOrders('resetOrders')"
              type="button"
              name="resetOrders"
              class="btn btn-sm btn-info"
            >
              Сбросить заявки
            </button>
          </div>
        </template>
        <template v-if="tableType == 'assignedOrders'">
          <div>
            <button
              @click="updateOrders('saveLineOrder')"
              type="button"
              name="saveLineOrder"
              class="btn btn-sm btn-info"
            >
              Сохранить порядок
            </button>
          </div>
          <template v-if="localInCallTaks[runnerId]">
            <div>
              <div class="alert alert-info">
                Отправлено на прозвон: {{ localInCallTaks[runnerId] }}
              </div>
            </div>
          </template>
          <template v-else>
            <div>
              <button
                @click="updateOrders('sendToCallList')"
                type="button"
                name="sendToCallList"
                class="btn btn-sm btn-success"
              >
                Отправить на прозвон
              </button>
            </div>
          </template>
          <div>
            <button
              @click="updateOrders('setOrdersDelivered')"
              type="button"
              name="setOrdersDelivered"
              class="btn btn-sm btn-success"
            >
              Пометить доставленными
            </button>
          </div>
        </template>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api";
import * as _ from "lodash";
import StoreSelect from "@/views/admin/components/StoreSelect";
import * as Ladda from "ladda";
import customModal from "@/components/modals/customModal";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    customModal,
    vSelect
  },
  data() {
    return {
      Toast: this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      }),
      selectedFreeOrders: {},
      hasFreeOrders: false,
      metroList: [],
      metro_lines: {
        "Сокольническая линия": {color: "#D92B2C", line: 1},
        "Замоскворецкая линия": {color: "#4DBE52", line: 2},
        "Арбатско-Покровская линия": {color: "#2C75C4", line: 3},
        Филёвская: {color: "#4DC6F4", line: 4},
        "Кольцевая линия": {color: "#85412E", line: 5},
        "Калужско-Рижская линия": {color: "#F07025", line: 6},
        "Таганско-Краснопресненская линия": {color: "#89339E", line: 7},
        "Калининско-Солнцевская линия": {color: "#FBC81E", line: 8},
        "Серпуховско-Тимирязевская линия": {color: "#9F9F9F", line: 9},
        "Люблинско-Дмитровская линия": {color: "#A8D92D", line: 10},
        "Московское центральное кольцо": {color: "#000000", line: 13}
      },
      modalData: null,
      localInCallTaks: null
    };
  },
  props: [
    "orders",
    "searchValueForReplace",
    "runnerId",
    "updateOrdersArrays",
    "tableType",
    "selected_runner",
    "selected_free_orders",
    "runners",
    "inStore",
    "inTransit",
    "requestedPreps",
    "colors",
    "colors_num",
    "onCallTask"
  ],
  watch: {
    selectedFreeOrders: function () {
      this.hasFreeOrders = Object.keys(this.selectedFreeOrders).length > 0;
    }
  },
  created() {
    this.localInCallTaks = this.onCallTask;
  },
  methods: {
    printOrderId(id) {
      var str = id.toString();
      return (
        '<span class="text-muted-light">' +
        str.substr(0, 1) +
        "</span>" +
        str.substr(1)
      );
    },
    getRebookDates(date) {
      var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;

      let dates = [];
      for (var i = 1; i <= 15; i++) {
        var st = new Date(date.replace(pattern, "$3-$2-$1"));
        var d = new Date(st.setDate(st.getDate() + i));
        dates.push({
          days: i,
          date:
            ("0" + d.getDate()).slice(-2) +
            "." +
            ("0" + (d.getMonth() + 1)).slice(-2)
        });
      }

      return dates;
    },
    async getMetroByApi(btn, order) {
    },
    async updateOrder(btn, id, type) {
      btn.target.disabled = true;

      var myPromise = new Promise(async (resolve, reject) => {
        switch (type) {
          case "rebookOrder":
            var days = 0;
            this.orders.forEach((o, i) => {
              if (o.id === id) days = o.rebookDate;
            });
            let {data} = await api.store(
              "/runners/orders/updateOrderByAction",
              {
                order_id: id,
                action: type,
                rebookDays: days
              }
            );
            if (data.success) {
              this.orders.forEach(o => {
                if (o.id === id) {
                  o.date = data.new_date;
                  o.showRebook = false;
                }
              });
            }
            break;

          case "rejectOrder":
            this.orders.forEach(async (o, i) => {
              if (o.id === id) {
                if (o.prichina_otkaza.length < 5) {
                  this.Toast.fire({
                    type: "warning",
                    title: "Укажите причину отказа (более 5-ти символов)"
                  });
                  // btn.target.disabled = false;
                  console.log("error");
                  resolve({});
                  return;
                }
                console.log("saving");
                let {data} = await api.store(
                  "/runners/orders/updateOrderByAction",
                  {
                    order_id: id,
                    action: type,
                    prichina_otkaza: o.prichina_otkaza
                  }
                );
                if (data.success) {
                  console.log("updating");
                  await this.$emit("externalUpdateOrders", id, this.tableType);
                  resolve(data);
                } else {
                  resolve(data);
                }
                return;
              }
            });
            break;

          default:
            resolve({});
            break;
        }
        resolve({});
      });

      const data = await myPromise;
      if (!Object.keys(data).length) {
        btn.target.disabled = false;
        console.log("exit");
        return;
      }
      console.log("exit2");
      if (data.success) {
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });
      } else {
        this.Toast.fire({
          type: "warning",
          title: data.message
        });
      }
      btn.target.disabled = false;
    },
    showRebookOptions(id) {
      this.orders.map(o => {
        if (o.id == id) {
          o.rebookDates = this.getRebookDates(o.date);
          o.showRebook = true;
        }
      });
    },
    showRejectMenu(id) {
      this.orders.map(o => {
        if (o.id == id) {
          o.showRejectMenu = true;
        }
      });
    },
    printPhone(phone) {
      if (phone.phone.length == 10) {
        return (
          "+" +
          phone.phone.country_code +
          " " +
          phone.phone.phone.replace(
            /(\d\d\d)(\d\d\d)(\d\d)(\d\d)/,
            "$1 $2 $3 $4"
          )
        );
      } else {
        return phone.phone.full_phone;
      }
    },
    async updateNoAnswerCalls() {
      let {data} = await api.store("/runners/orders/updateNoAnswerCalls", {
        order_id: this.modalData.orderId,
        action: "noAnswerCallOrder"
      });
      if (data.success) {
        this.orders.map(order => {
          if (order.id == this.modalData.orderId) {
            order.num_nedozvonov = data.number;
          }
        });
        if (data.remove) {
          this.$emit(
            "externalUpdateOrders",
            this.modalData.orderId,
            this.tableType
          );
        }
      }
      this.modalData = null;
    },
    onModalClose() {
      this.modalData = null;
    },
    printnoAnswerCalls(num) {
      if (!num) return "";
      return '<span class="no_call">Недозвон: <b>' + num + "</b>";
    },
    noAnsverPhoneCall(orderId, phone) {
      this.modalData = {
        orderId: orderId,
        header: "Действительно недозвон?",
        body: "<b>" + phone + "</b>",
        acceptBtnText: "Да",
        cancelBtnText: "Нет"
      };
    },
    printMetro(order) {
      if (!order.metro) {
        if (!order.text_metro) return;
        try {
          var m = JSON.parse(order.text_metro);
        } catch (e) {
          return order.text_metro;
        }
        return m.station;
      }
      return (
        '<p class="metro_line">' +
        order.metro.line.title +
        '</p><p><i class="icon-fa icon-fa-subway"></i>' +
        order.metro.title +
        "</p>"
      );

      try {
        let metro = JSON.parse(order.metro);
        let style_num = "";
        let number = "";
        if (typeof this.metro_lines[metro.line] !== "undefined") {
          style_num = this.metro_lines[metro.line].line;
        }
        if (style_num !== "") {
          number =
            '<span class="metro_line metro_line_' +
            style_num +
            '">' +
            style_num +
            "</span>";
          metro.line = metro.line.replace(" линия", "");
          metro.station = metro.station.replace("метро ", "");
        }
        return (
          "<p>" +
          number +
          metro.line +
          '</p><p><i class="icon-fa icon-fa-subway"></i>' +
          metro.station +
          "</p>"
        );
      } catch (e) {
        return order.metro;
      }
    },
    printFigures(prep) {
      let html = "";
      html += "<p>На складе: " + this.inStore[prep.prep] + "</p>";
      html += "<p>Всего требуется: " + this.requestedPreps[prep.prep] + "</p>";
      try {
        if (this.inTransit.in[prep.prep].total) {
          Object.keys(this.inTransit.in[prep.prep].transits).forEach(key => {
            html +=
              "<p>Следует на склад: " +
              this.inTransit.in[prep.prep].transits[key] +
              " - (" +
              key +
              ")</p>";
          });

          // this.inTransit.in[prep.prep].transits.forEach((t, i) => {
          //     html += '<p>Следует на склад: ' + t + ' - (' + i + ')</p>';
          // });
          // html += '<p>Следует на склад: ' + this.inTransit.in[prep.prep].total + '</p>'
        }
        if (this.inTransit.out[prep.prep]) {
          html +=
            "<p>Следует со склада: " + this.inTransit.out[prep.prep] + "</p>";
        }
      } catch (e) {
      }
      return html;
    },
    showCommentButton(id, show = true) {
      this.orders.map((order, index) => {
        if (order.id == id) {
          order.comment_btn = show;
        }
      });
    },
    toggleAllCheckboxes() {
      let main = this.$refs.form.querySelectorAll("input.main_checkbox")[0]
        .checked;
      let checkboxes = this.$refs.form.querySelectorAll(
        "input.select_checkbox"
      );
      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = main;
      }
    },
    sortByField(Objects, field) {
      if (field === "ord") {
        return _.orderBy(
          Objects,
          o => {
            return new Number(o[field]);
          },
          "asc"
        );
      }
      return _.orderBy(Objects, field, "asc");
    },
    printSumm(order) {
      let sum = 0;
      Object.keys(order.details).forEach(key => {
        sum += order.details[key].qty * order.details[key].price;
      });
      if (order.discount_type == 0) {
        sum -= order.discount;
      } else {
        sum -= (sum * order.discount) / 100;
      }
      return sum + order.delivery_price * 1;
    },
    saveComment: async function (e) {
      e.preventDefault();

      let btn = Ladda.create(e.target.querySelector("button"));
      btn.start();

      let {data} = await api.store("/runners/orders/updateComment", {
        order_id: e.target.order_id.value,
        comment: e.target.comment.value
      });

      if (data.success) {
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });
      } else {
        this.Toast.fire({
          type: "warning",
          title: "Ошибка сохранения"
        });
      }
      btn.stop();
      this.showCommentButton(e.target.order_id.value, false);
    },
    selectFreeOrder(id) {
      if (!Object.keys(this.orders)) return;
      if (!Object.keys(this.selected_runner).length) return;

      if (this.selectedFreeOrders[id]) {
        delete this.selectedFreeOrders[id];
      } else {
        this.selectedFreeOrders[id] = true;
      }
      this.selectedFreeOrders = {...this.selectedFreeOrders};
    },
    async updateOrders(type) {
      let btn = Ladda.create(
        this.$refs.form.querySelector('button[name="' + type + '"]')
      );
      btn.start();

      let id = this.runnerId;
      let Form = new FormData(this.$refs.form);
      Form.append("type", type);
      Form.append("runner_id", id);
      let {data} = await api.store("/runners/orders/updateOrders", Form);

      if (type == "resetOrders") {
        let checkboxes = this.$refs.form.querySelectorAll(
          "input.select_checkbox"
        );
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false;
        }
      }

      if (!data.success) {
        btn.stop();
        this.Toast.fire({
          type: "warning",
          title: data.message || "Ошибка"
        });

        return;
      }

      if (data.success) {
        if (type == "saveLineOrder") {
          Object.keys(data.line).forEach(key => {
            this.orders.map((order, index) => {
              if (order.id == key) {
                this.orders[index].ord = data.line[key];
              }
            });
          });
          this.updateOrdersArrays(this.orders, id, id, true);
          btn.stop();
          return;
          // this.runners_orders[id] = _.cloneDeep(this.originalOrders[id]);
        }

        if (type == "resetOrders") {
          this.updateOrdersArrays(data.orders, id, 0);
          btn.stop();
          return;
        }

        btn.stop();
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });

        console.log(type);
        if (type == "sendToCallList") {
          this.localInCallTaks[this.runnerId] = "Сейчас";
          console.log(this.localInCallTaks);
          this.$refs.form.querySelector('button[name="' + type + '"]').remove();
        }
      }
    },
    async sendFreeOrders() {
      let btn = Ladda.create(this.$refs.assignButton);
      btn.start();
      let {data} = await api.store("/runners/orders/assignOrders", {
        action: "assignOrders",
        runner: this.selected_runner,
        selected_orders: this.selectedFreeOrders
      });

      if (!data.success) {
        this.Toast.fire({
          type: "warning",
          title: data.message ? data.message : "Ошибка"
        });
        btn.stop();
        return;
      }

      await this.updateOrdersArrays(data.orders, 0, this.selected_runner);

      this.selectedFreeOrders = {};

      this.Toast.fire({
        type: "success",
        title: "Сохранено"
      });
      btn.stop();
    },
    getRunnerName() {
      if (!Number.isInteger(this.selected_runner)) {
        if (this.selected_runner == "pause") return "Отстойник";
        if (this.selected_runner == "future") return "Будущие заявки";
      }
      return this.runners[this.selected_runner];
    },
    onSearchMetro(search, loading) {
      if (!search || search.length < 3) return;
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      fetch(
        `/api/v1/getMetroStation?search=${encodeURIComponent(search)}`
      ).then(res => {
        res.json().then(json => (vm.metroList = json.items));
        loading(false);
      });
    }, 700),
    async saveMetro(btn, order) {
      btn.target.disabled = true;
      let {data} = await api.store("/orders/updateOrderByAction", {
        action: "saveMetro",
        order_id: order.id,
        metro: order.metro
      });
      if (data.success) {
        this.Toast.fire({
          type: "success",
          title: "Сохранено"
        });
        order.showMetroMenu = false;
      } else {
        this.Toast.fire({
          type: "warning",
          title: data.message ? data.message : "Ошибка"
        });
      }
      btn.target.disabled = false;
    }
  }
};
</script>

<style>
.flex-padding-10 div {
  padding-right: 5px;
}

.flex .alert-info {
  padding: 3px 10px;
}

td.red {
  background-color: rgb(252, 196, 196, 0.4) !important;
}

td.yellow {
  background-color: rgba(255, 187, 0, 0.4) !important;
}

td.blue {
  background-color: rgb(188, 226, 244, 0.4) !important;
}

.no_call {
  color: red;
}

.p-t-5 {
  padding-top: 5px;
}

.vs__search::placeholder {
  color: #a8a8a8;
}

.text-muted-light {
  color: #e3e3e3 !important;
}

.mw-180 {
  min-width: 180px;
}

.w-100 {
  width: 100%;
}

.tooltip.info .tooltip-inner {
  background: rgba(91, 191, 222);
}

.metro_td p,
.phone_td p {
  margin-bottom: 2px;
}

.phone_td span:before {
  position: absolute;
  left: 7px;
  content: " ";
  height: 22px;
  transform: rotate(45deg);
  width: 2px;
  background-color: red;
}

.phone_td span {
  position: relative;
}

.phone_td .icon-fa-phone {
  color: red;
}

.metro_td .icon-fa {
  margin-right: 5px;
  padding-left: 2px;
  cursor: default;
}

.metro_line {
  /*color: white;*/
  font-size: 12px;
  padding: 2px 7px;
  margin-right: 5px;
  border-radius: 50px;
}

.metro_line_1 {
  background-color: #d92b2c;
}

.metro_line_2 {
  background-color: #4dbe52;
}

.metro_line_3 {
  background-color: #2c75c4;
}

.metro_line_4 {
  background-color: #4dc6f4;
}

.metro_line_5 {
  background-color: #85412e;
}

.metro_line_6 {
  background-color: #f07025;
}

.metro_line_7 {
  background-color: #89339e;
}

.metro_line_8 {
  background-color: #fbc81e;
}

.metro_line_9 {
  background-color: #9f9f9f;
}

.metro_line_10 {
  background-color: #a8d92d;
}

.metro_line_13 {
  background-color: #000000;
}
</style>

<style scoped>
.btn-xs {
  padding: 0px 8px !important;
}

.table td,
.table th {
  padding: 2px 10px;
}

.phone_td {
  min-width: 140px;
}

.table label {
  margin: 0;
}

.table textarea {
  font-size: 11px;
  line-height: initial;
  min-width: 150px;
  min-height: 65px;
  padding: 4px;
}

.table p {
  margin-bottom: 2px;
}

label {
  cursor: pointer;
}

.table td.call_before {
  background-color: #bce2f4;
}

.bold_info {
  font-weight: 600;
}

.table th {
  white-space: normal;
}

.div_sticky_btn {
  top: 80px;
  text-align: right;
}

tr.selected,
tr.selected:hover {
  background-color: #a7cee0 !important;
}

.assignButton {
  position: absolute;
  right: 0;
}

.flex {
  display: flex;
}

.flex i {
  margin-right: 5px;
}

.w-75 {
  width: 75%;
}

.back_green {
  background-color: #b7edc1;
}
</style>
